import type { Button } from '@sats-group/ui-lib/react/button/button.types';
import type { LinkButton } from '@sats-group/ui-lib/react/link-button/link-button.types';
import type { Message } from '@sats-group/ui-lib/react/message/message.types';
import type { Modal } from '@sats-group/ui-lib/react/modal/modal.types';
import type { Tag } from '@sats-group/ui-lib/react/tag/tag.types';

import type { ArrowButton } from 'shared/components/arrow-button/arrow-button.props';
import type { Logo } from 'shared/components/logo/logo.props';
import type { QrCode } from 'shared/components/qr-code/qr-code.props';

import type { Language } from 'utils/resolve-language';

export const tagIconNames = {
  dot: 'dot',
  male: 'male',
  female: 'female',
} as const;

type TagIconName = (typeof tagIconNames)[keyof typeof tagIconNames];

type BaseStep = {
  benefits: string[];
  preTitle: string;
  tag: Tag;
  title: string;
};

type AppStep = BaseStep & {
  appStoreHref: string;
  appStoreLabel: string;
  button: Button;
  googlePlayHref: string;
  googlePlayLabel: string;
  modal: Modal;
  qrCode: QrCode;
  qrCodeHelpText: string;
};

type HubStep = BaseStep & {
  link: LinkButton;
};

type PtTrialStep = BaseStep & {
  button: Button;
  handheldHref: string;
  modal: Modal;
  qrCode: QrCode;
  qrCodeHelpText: string;
};

export type Confirmation = {
  additionalInformation: {
    title: string;
    blocks: {
      title: string;
      text: string;
      link?: LinkButton;
    }[];
  };
  emailDescription: string;
  hasDaysUntilMembershipStarts: boolean;
  language: Language;
  logo: Logo;
  membershipDetails: {
    button: ArrowButton;
    modal: Modal;
    sections: {
      title: string;
      items: {
        label: string;
        value: string;
        copyButton?: Button;
        tag?: Omit<Tag, 'icon'> & {
          iconName?: TagIconName;
        };
      }[];
    }[];
  };
  messages: Message[];
  mood?: 'celebratory';
  nextSteps: {
    appStep?: AppStep;
    hubStep?: HubStep;
    ptTrialStep?: PtTrialStep;
    title: string;
  };
  summaryCard: {
    back?: {
      addons: Tag[];
      addonsTitle: string;
      otherPayer?: Tag;
      otherPayerTitle?: string;
    };
    front: {
      activationTag: string;
      groupTrainingIncluded?: {
        groupTraining: string;
        included: string;
      };
      member: string;
      membershipDescription?: string;
      membershipName: string;
    };
  };
  startDateDescription: string;
  optimizelyTrackingEvent?: object; // NOTE: We don't care about the type here, we just want to pass it through.
  subTitle: string;
  title: string;
};
